import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/**
 * Парсит строку формата yyyy-mm-dd HH:MM:ss в объект Date
 */
export var parseStringToDate = function parseStringToDate(str, timezoneDiff) {
  var _str$split = str.split(' '),
    _str$split2 = _slicedToArray(_str$split, 2),
    date = _str$split2[0],
    time = _str$split2[1];
  var dateArgs = date.split('-').map(Number);
  var timeArgs = time.split(':').map(Number);
  var year = dateArgs[0];
  var month = dateArgs[1] - 1;
  var day = dateArgs[2];
  var hours = timeArgs[0];
  var minutes = timeArgs[1];
  var seconds = timeArgs[2] || 0;
  var dateObj = new Date(year, month, day, hours, minutes, seconds);
  dateObj.setMinutes(dateObj.getMinutes() - timezoneDiff);
  return dateObj;
};